// extracted by mini-css-extract-plugin
module.exports = {"blur":"tab_content__blur___3IEJj"};